import { ApplicationView as view } from '@aha-app/mvc';
import React from 'react';
import ActionMenuItem from './ActionMenuItem';
import SelectionContextSubmenu from './SelectionContextSubmenu';
import type RecordAction from './models/RecordAction';

const CommonActionItem: React.FC<{ action: RecordAction }> = ({ action }) => {
  if (action.hasSubmenu) {
    return <SelectionContextSubmenu action={action} />;
  } else {
    return <ActionMenuItem action={action} />;
  }
};

export default view(CommonActionItem);
